import type { Confidence, Provenance } from '@shared/types';

const labels: Record<Confidence, string> = {
  verified_seed: 'Seed · dated',
  assumption: 'Assumption',
  unverified: 'UNVERIFIED',
};

export function ProvenanceNote({ provenance, className = '' }: { provenance: Provenance; className?: string }) {
  return (
    <p className={`text-[11px] leading-relaxed text-faint ${className}`}>
      <span className={provenance.confidence === 'unverified' ? 'font-semibold text-alert' : 'font-semibold'}>
        {labels[provenance.confidence]}
      </span>
      {provenance.verifiedAt ? ` · ${provenance.verifiedAt}` : ''}
      {provenance.source ? ` · ${provenance.source}` : ''}
    </p>
  );
}
